import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeCreditCardCommand extends BaseCommand {
  CommandName = "ChangeCreditCard";
  Command: {
    CreditCardId: number | null;
    CreditCardNumber: string;
    BookingItemTmpId: string;
  };
  constructor(
    sessionId: string,
    operationId: string,
    bookingItemTmpId: string,
    creditCardId: number | null,
    creditCardNumber: string
  ) {
    super(sessionId, operationId);
    this.Command = {
      BookingItemTmpId: bookingItemTmpId,
      CreditCardId: creditCardId,
      CreditCardNumber: creditCardNumber,
    };
  }
}
